import { GlobalToolbarLink, ICON_NAMES } from '../../../components/GlobalToolbar/Components';
import { getUserGuideUrl } from '../utils/getUserGuideUrl';
import { jsx as _jsx } from "react/jsx-runtime";
export const UserGuideButton = () => {
  return /*#__PURE__*/_jsx(GlobalToolbarLink, {
    id: "grow-guide-user-guide-button",
    iconName: ICON_NAMES.GROW_GUIDE,
    itemName: "User Guide",
    href: getUserGuideUrl(),
    ariaLabelKey: "nav.icons.userGuide",
    iconTitleKey: "nav.icons.userGuide"
  });
};